import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RefrigerationBuilder } from '../../models/builders/refrigeration.builder';
import { Refrigeration } from '../../models/refrigeration';
import { RefrigerationGroup } from '../../models/refrigeration-group';

const refrigerationBody = (refrigeration: Refrigeration) => ({
  name: refrigeration.name,
  value: refrigeration.value
});

@Injectable()
export class RefrigerationApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }refrigerations`;
  }

  getRefrigerationsByGroup(refrigerationGroup: RefrigerationGroup) {
    const params = new HttpParams()
      .append('refrigerationGroup', refrigerationGroup.name);

    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(map(RefrigerationBuilder.fromList));
  }

  createRefrigeration(refrigeration) {
    return this.httpClient.post(this.apiUrl, refrigerationBody(refrigeration)).pipe(map(RefrigerationBuilder.fromJson));
  }

  deleteRefrigeration(refrigeration: Refrigeration) {
    return this.httpClient.delete(`${ this.apiUrl }/${ refrigeration.hash }`);
  }

  getRefrigerations() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(RefrigerationBuilder.fromList));
  }

  getSimpleRefrigerations() {
    return this.httpClient.get(`${ this.apiUrl }/simple/refrigerations`).pipe(map(RefrigerationBuilder.fromList));
  }

  getRefrigeration(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(RefrigerationBuilder.fromJson));
  }

  updateRefrigeration(refrigeration: Refrigeration) {
    return this.httpClient.put(`${ this.apiUrl }/${ refrigeration.hash }`, refrigerationBody(refrigeration));
  }

  getRefrigerationsByModel(model: string) {
    const params = new HttpParams()
      .append('model', model);

    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(map(RefrigerationBuilder.fromList));
  }

  getRefrigerationsByRefrigerationGroup(refrigerationGroup: RefrigerationGroup) {
    return this.getRefrigerationsByGroup(refrigerationGroup);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/refrigeration-api.service.ts